// extracted by mini-css-extract-plugin
export default {"wrapper":"ys-z","response":"zs-z","error":"As-z","disabled":"Bs-z","buttons":"Cs-z","feedbackQuestionSection":"Ds-z","yesNoWrapper":"Es-z"};